<div class="navbar-container">
  <!-- Top navbar -->
  <mat-toolbar class="navbar" color="primary">
    <button mat-icon-button (click)="snav.toggle()" *ngIf="token">
      <mat-icon>menu</mat-icon>
    </button>

    <a class="navbar-brand" matTooltip="Home">
      <h1>Seneca Music</h1>
    </a>

    <span class="navbar-spacer"></span>

    <button mat-button [matMenuTriggerFor]="userMenu" *ngIf="token">
      <mat-icon>person</mat-icon>
      <span fxShow fxHide.xs> {{ token.userName }} </span>
    </button>
    <mat-menu
      #userMenu="matMenu"
      xPosition="before"
      yPosition="above"
      [overlapTrigger]="false"
    >
      <a mat-menu-item (click)="logout()">
        <mat-icon>exit_to_app</mat-icon>
        <span>Log out</span>
      </a>
    </mat-menu>
  </mat-toolbar>

  <mat-sidenav-container>
    <!-- Side nav -->
    <mat-sidenav
      #snav
      [opened]="token && snav.opened"
      [mode]="'side'"
      [fixedInViewport]="true"
      fixedTopGap="56"
    >
      <mat-nav-list>
        <div>
          <mat-form-field appearance="fill">
            <mat-label>Artist</mat-label>
            <form (ngSubmit)="handleSearch()">
              <input
                matInput
                type="text"
                name="searchString"
                [(ngModel)]="searchString"
              />
            </form>
          </mat-form-field>
        </div>

        <a mat-list-item>
          <mat-icon mat-list-icon> library_music </mat-icon>
          <a
            class="nav-link"
            routerLink="/newReleases"
            routerLinkActive="active"
            >New Releases
          </a>
        </a>

        <a mat-list-item routerLink="/favourites" routerLinkActive="active">
          <mat-icon mat-list-icon> favorite </mat-icon>
          <p mat-line>Favourites</p>
        </a>

        <a mat-list-item routerLink="/login" routerLinkActive="active">
          <mat-icon mat-list-icon> login </mat-icon>
          <p mat-line>Login</p>
        </a>

        <a mat-list-item routerLink="/register" routerLinkActive="active">
          <mat-icon mat-list-icon> Register </mat-icon>
          <p mat-line>Register</p>
        </a>

        <mat-divider></mat-divider>

        <a
          id="push-bottom"
          mat-list-item
          routerLink="/about"
          routerLinkActive="active"
        >
          <mat-icon mat-list-icon> info_outline </mat-icon>
          About
        </a>
      </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content class="sidenav-content">
      <!-- Main content -->
      <router-outlet></router-outlet>
      <!-- ------------ -->

      <div class="bottom-spacer"></div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
